import React, { useState, useEffect } from 'react';
import './Clock.css'

export default React.memo(function Clock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const hh = now.getHours().toString().padStart(2, '0');
  const mm = now.getMinutes().toString().padStart(2, '0');
  const date = now.toLocaleDateString();

  return (
    <div className="time-date">
      <span className="time">{hh}:{mm}</span>
      <span className="date">{date}</span>
    </div>
  );
});
